import { render, staticRenderFns } from "./FrontSingleProduct.vue?vue&type=template&id=6b7cf00f&"
import script from "./FrontSingleProduct.vue?vue&type=script&lang=js&"
export * from "./FrontSingleProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports